// extracted by mini-css-extract-plugin
module.exports = {"a11yOnly":"global__a11yOnly--3n7m7","focusable":"global__focusable--_TM4N"};